import {messages as portugueseMessages} from './pt'
import {messages as englishMessages} from './en'
import {messages as spanishMessages} from './es'
import {messages as frenchMessages} from './fr'
import {messages as germanyMessages} from './de'
import {messages as italianMessages} from './it'
import {messages as mandarinMessages} from './zh'
import {messages as koreanMessages} from './ko'
import {messages as japaneseMessages} from './ja'

const messages = {
  ...portugueseMessages,
  ...englishMessages,
  ...spanishMessages,
  ...frenchMessages,
  ...germanyMessages,
  ...italianMessages,
  ...mandarinMessages,
  ...koreanMessages,
  ...japaneseMessages,
}

export {messages}
